import React from 'react';
import styled from 'styled-components';
import { Icon } from 'components/common/Icon';
import { CenterRowDiv, Div, Span, Text, theme } from 'styles';

export function EnergyText({ type, label, $empty, children }) {
  const types = { all: theme.colors.primary, case1: theme.colors.primary100, case2: '#FFA58A', case3: '#F5E292' };

  return (
    <CustomDiv $bgColor="gray100" $flex={1}>
      <CenterRowDiv $gap={8}>
        <Icon name="Info" $pathFill={types[type] || types.all} $width={21} $height={21} />
        <Text $type="m16" $color="supportive">
          {label}
        </Text>
      </CenterRowDiv>
      <CustomDiv $bgColor="white" $marginTop={8}>
        {$empty ? (
          <>{children}</>
        ) : (
          <Text $type="m18" $textAlign="end">
            {Number(children).toLocaleString()}
            <Span $color="primary" $type="m16" $paddingLeft={4}>
              Kw
            </Span>
          </Text>
        )}
      </CustomDiv>
    </CustomDiv>
  );
}

const CustomDiv = styled(Div)`
  padding: 8px;
  border-radius: 8px;
`;
